<div [class]="'d-flex flex-column gap-m mrxs ' + (clazz ? clazz : '')">
  <ng-content></ng-content>
</div>
@if (loading) {
  <pr-loader></pr-loader>
}
